import { Storage } from "@capacitor/storage";
import { sum } from "d3";
import { User } from "../models/data";
import Urls from "./url";


export const fetchUserCredit = async (id: any) => {
    const url = Urls('userCreditUrl', id);
    let resp = await fetch(url).then((resp) => {

        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const fetchUserBalance = async (id: any) => {
    let credit: number[] | null = [];
    let donation: number[] | null = [];
    await fetchUserCredit(id).then(
        m => {
            if (m.message) {
                let credits = m.message;
                credits.forEach(
                    (item: any) => {
                        if (item.acf.status === "completed") {
                            credit!.push(parseFloat(item.acf.amount))
                        }
                    }
                )
            } else {
                credit = null;
            }

        }
    )
    await fetchUserDonations(id).then(
        m => {
            if (m.message) {
                let donations = m.message;
                donations.forEach(
                    (item: any) => {
                        if (item.acf.donation_method === "sw_account" && item.acf.status === "completed") {
                            donation!.push(parseFloat(item.acf.amount))
                        }
                    }
                )
            } else {
                donation = null
            }
        }
    )

    if (credit && donation) {
        return (sum(credit) - sum(donation))
    } else {
        return "error";
    }
}

export const fetchUserDonations = async (id: any) => {
    const url = Urls('userDonationsUrl', id);
    let resp = await fetch(url).then((resp) => {
        return resp
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}
export const fetchUserCredits = async (id: any) => {
    const url = Urls('userCreditsUrl', id);
    let resp = await fetch(url).then((re) => {
        return re
    })

    if (resp.ok) {
        return {
            message: await resp.json(),
            error: null
        }
    } else {
        return {
            message: null,
            error: resp.statusText
        }
    }
}

export const createDonation = async (data: any) => {
    let user: User;
    const { value } = await Storage.get({ key: 'user' });
    if (value) {
        user = JSON.parse(value);
        const createResponse = await fetch(Urls('createDonationUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify({ title: data.title }) // body data type must match "Content-Type" header

        })
        if (createResponse.ok) {
            let message = await createResponse.json();
            let id = await message.id;
            let updateResponse = await updateDonation(data, id);
            if (updateResponse?.update_message) {
                return {
                    message: updateResponse.update_message,
                    error: null
                }
            } else {
                return {
                    message: null,
                    error: updateResponse?.update_message
                }
            }
        } else {
            return {
                message: null,
                error: createResponse.statusText
            }
        }
    } else {
        console.log('no user');
    }
}
export const updateDonation = async (data: any, id: any) => {
    let user: User;
    const { value } = await Storage.get({ key: 'user' });

    let body = {
        status: data.status,
        acf: data.acf
    }
    if (value) {
        user = JSON.parse(value);
        const updateResponse = await fetch(Urls('updateDonationUrl', id), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        })
        if (updateResponse.ok) {
            return {
                update_message: await updateResponse.json(),
                update_error: null
            }
        } else {
            console.log(await updateResponse.json())
            return {
                update_message: null,
                update_error: updateResponse.statusText
            }
        }
    } else {
        console.log('no user');
    }
}
export const createCredit = async (data: any) => {
    let user: User;
    const { value } = await Storage.get({ key: 'user' });
    if (value) {
        user = JSON.parse(value);
        const createResponse = await fetch(Urls('createCreditUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify({ title: data.title }) // body data type must match "Content-Type" header

        })
        if (createResponse.ok) {
            let message = await createResponse.json();
            let id = await message.id;
            let updateResponse = await updateCredit(data, id);
            if (updateResponse?.update_message) {
                return {
                    message: updateResponse.update_message,
                    error: null
                }
            } else {
                return {
                    message: null,
                    error: updateResponse?.update_message
                }
            }
        } else {
            return {
                message: null,
                error: createResponse.statusText
            }
        }
    } else {
        console.log('no user');
    }
}
export const updateCredit = async (data: any, id: any) => {
    let user: User;
    const { value } = await Storage.get({ key: 'user' });

    let body = {
        status: data.status,
        acf: data.acf
    }
    if (value) {
        user = JSON.parse(value);
        const updateResponse = await fetch(Urls('updateCreditUrl', id), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        })
        if (updateResponse.ok) {
            return {
                update_message: await updateResponse.json(),
                update_error: null
            }
        } else {
            return {
                update_message: null,
                update_error: updateResponse.statusText
            }
        }
    } else {
        console.log('no user');
    }
}

export const fetchUserBalance_b = async (id: any) => {

    let user: User;

    const { value } = await Storage.get({ key: 'user' });

    
    if (value) {
        user = JSON.parse(value);
        let body = {id:id}

        let resp = await fetch(Urls('userBalanceUrl'), {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer ' + user.token,
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(body) // body data type must match "Content-Type" header

        })

        if (resp.ok) {
            return {
                message: await resp.json(),
                error: null
            }
        } else {
            return {
                message: null,
                error: resp.statusText
            }
        }
    }
}

